import React from 'react'
import { css, Global } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import {
  RESERVATION_TASK_HANDLING_STATUSES,
  ReservationTaskHandlingStatus,
  reservationTaskHandlingStatusLabelKeys,
} from '@/models/reservation/reservation-task'

/** 対応ステータスのメニューを出す Popover に付けるクラス */
export const HANDLING_STATUS_POPOVER_CLASS = 'reservation-task-handling-status-popover'

/**
 * Popover の余白と矢印を消す。既存の RoomAssignStatusSelect は同じ指定をクラスで絞らずに入れており、
 * マウント中は画面のすべての Popover に効いてしまうため、ここではこのクラスの Popover だけに効かせる
 */
export const HandlingStatusPopoverStyle: React.FC = () => (
  <Global
    styles={css({
      [`.${HANDLING_STATUS_POPOVER_CLASS}.ant-popover`]: { paddingTop: 4 },
      [`.${HANDLING_STATUS_POPOVER_CLASS} .ant-popover-inner-content`]: { padding: 0 },
      [`.${HANDLING_STATUS_POPOVER_CLASS} .ant-popover-arrow`]: { display: 'none' },
    })}
  />
)

type Props = {
  onSelect: (status: ReservationTaskHandlingStatus) => void
}

export const HandlingStatusMenu: React.FC<Props> = ({ onSelect }) => {
  const { t } = useTranslation()
  return (
    <ul css={menuStyle}>
      {RESERVATION_TASK_HANDLING_STATUSES.map(status => (
        <li key={status} css={menuItemStyle} onClick={() => onSelect(status)}>
          {t(reservationTaskHandlingStatusLabelKeys[status])}
        </li>
      ))}
    </ul>
  )
}

const menuStyle = css({
  minWidth: 120,
  padding: '4px 0',
})

const menuItemStyle = css({
  display: 'flex',
  alignItems: 'center',
  height: 34,
  padding: '0 16px',
  listStyle: 'none',
  fontSize: 14,
  color: '#272727',
  cursor: 'pointer',
  '&:hover': { background: '#F2F2F2' },
})
